import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, OG_IMAGE, seoConfig } from "../seo/seoConfig";
import {
  organizationSchema, physicianSchema, medicalClinicSchema,
  faqSchema, breadcrumbSchema, medicalConditionSchema, reviewSchema,
} from "../seo/schema";

// SEO component: sets per-page title, meta, canonical, OG/Twitter and JSON-LD schema.
const SEO = ({ path, faqs, reviews }) => {
  const cfg = seoConfig[path] || seoConfig["/"];
  const canonical = `${SITE_URL}${path === "/" ? "/" : path + "/"}`;

  const schemas = [
    organizationSchema(),
    medicalClinicSchema(),
    physicianSchema(),
    breadcrumbSchema(cfg.breadcrumb),
  ];
  if (faqs && faqs.length) schemas.push(faqSchema(faqs));
  if (reviews && reviews.length) schemas.push(reviewSchema(reviews));
  if (cfg.condition) schemas.push(medicalConditionSchema(cfg.condition, cfg.procedure));

  return (
    <Helmet>
      <title>{cfg.title}</title>
      <meta name="description" content={cfg.description} />
      <meta name="keywords" content={cfg.keywords} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="author" content="Dr. Indresh Dixit" />
      <meta name="geo.region" content="IN-UP" />
      <meta name="geo.placename" content="Varanasi" />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Dr. Indresh Dixit – Liver Specialist in Varanasi" />
      <meta property="og:title" content={cfg.title} />
      <meta property="og:description" content={cfg.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={cfg.title} />
      <meta name="twitter:description" content={cfg.description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};

export default SEO;
